export default __webpack_public_path__ + "0866beb6617ba85a66f8ed3d7646c41d.png";